// ============================================================
// MOCK DASHBOARD — benessere-posturale
// ============================================================

import {
  Course,
  UserProgress,
  FitAnatomyResource,
  Notification,
} from '../types/course';
import type { Progress } from '../types/course';
import { AdminOrder } from '../types/admin';

// ─── Corsi ───────────────────────────────────────────────────
export const MOCK_COURSES: Record<string, Course> = {
  'be-smart': {
    id: 'be-smart',
    title: 'BE SMART',
    subtitle: 'Il manuale per chi studia o lavora "in smart"',
    description:
      'BE SMART è il manuale che salva la schiena, un sacco di soldi e anche il futuro!',
    imageUrl: undefined,
    lessons: [
      {
        id: 'bs-l1',
        courseId: 'be-smart',
        order: 1,
        title: 'Introduzione: cosa troverai in questo corso',
        type: 'video',
        durationSeconds: 420,
        streamUrl:
          'https://storage.googleapis.com/shaka-demo-assets/angel-one/dash.mpd', // mock — sostituire con URL reale
        format: 'dash',
      },
      {
        id: 'bs-l2',
        courseId: 'be-smart',
        order: 2,
        title: 'La postura corretta alla scrivania',
        type: 'video',
        durationSeconds: 1080,
        streamUrl:
          'https://storage.googleapis.com/shaka-demo-assets/sintel/dash.mpd',
        format: 'dash',
      },
      {
        id: 'bs-l3',
        courseId: 'be-smart',
        order: 3,
        title: 'I 5 errori più comuni e come evitarli',
        type: 'video',
        durationSeconds: 960,
        streamUrl:
          'https://storage.googleapis.com/shaka-demo-assets/angel-one-hls/hls.m3u8',
        format: 'hls',
      },
      {
        id: 'bs-l4',
        courseId: 'be-smart',
        order: 4,
        title: '5 minuti di Coerenza Cardiaca',
        description: 'Traccia audio guidata per ridurre lo stress',
        type: 'audio',
        durationSeconds: 300,
        streamUrl:
          'https://storage.googleapis.com/shaka-demo-assets/angel-one/dash.mpd',
        format: 'dash',
      },
      {
        id: 'bs-l5',
        courseId: 'be-smart',
        order: 5,
        title: 'Esercizi pratici: serie mattutina',
        type: 'video',
        durationSeconds: 1320,
        streamUrl:
          'https://storage.googleapis.com/shaka-demo-assets/tos-ttml/dash.mpd',
        format: 'dash',
      },
      {
        id: 'bs-l6',
        courseId: 'be-smart',
        order: 6,
        title: 'Esercizi pratici: pausa attiva',
        type: 'video',
        durationSeconds: 780,
        streamUrl:
          'https://storage.googleapis.com/shaka-demo-assets/angel-one/dash.mpd',
        format: 'dash',
      },
      {
        id: 'bs-l7',
        courseId: 'be-smart',
        order: 7,
        title: 'La SMART SKILL per il tuo futuro',
        type: 'video',
        durationSeconds: 1500,
        streamUrl:
          'https://storage.googleapis.com/shaka-demo-assets/sintel-mp4-only/dash.mpd',
        format: 'mp4',
      },
    ],
    attachments: [
      {
        id: 'bs-pdf-1',
        title: 'Capitolo 1 — PDF',
        fileUrl: '/api/media/pdf/bs-cap1',
        fileSizeKb: 1240,
      },
      {
        id: 'bs-pdf-2',
        title: 'Scheda esercizi',
        fileUrl: '/api/media/pdf/bs-esercizi',
        fileSizeKb: 890,
      },
    ],
  },
};

// ─── Progresso utente mock ───────────────────────────────────
export const MOCK_USER_PROGRESS: UserProgress = {
  courses: {
    'be-smart': {
      courseId: 'be-smart',
      lastLessonId: 'bs-l3',
      completionPercent: 28,
      startedAt: '2025-03-01T10:00:00Z',
      lastAccessedAt: '2025-03-20T18:30:00Z',
      lessons: {
        'bs-l1': {
          lessonId: 'bs-l1',
          completed: true,
          progressSeconds: 420,
          lastWatchedAt: '2025-03-01T10:07:00Z',
        },
        'bs-l2': {
          lessonId: 'bs-l2',
          completed: true,
          progressSeconds: 1080,
          lastWatchedAt: '2025-03-05T14:20:00Z',
        },
        'bs-l3': {
          lessonId: 'bs-l3',
          completed: false,
          progressSeconds: 340, // si è fermato a 5:40
          lastWatchedAt: '2025-03-20T18:30:00Z',
        },
      },
    },
  },
};

// ─── Risorse Fit Anatomy ─────────────────────────────────────
export const MOCK_FIT_ANATOMY_RESOURCES: FitAnatomyResource[] = [
  {
    id: 'fa-1',
    title: 'Guida alla respirazione diaframmatica',
    description: 'PDF introduttivo alla respirazione corretta',
    type: 'pdf',
    fileUrl: '/api/media/pdf/fa-respirazione',
    fileSizeKb: 780,
  },
  {
    id: 'fa-2',
    title: '5 minuti di Coerenza Cardiaca',
    description: 'Traccia audio guidata dalla voce di Nicoletta',
    type: 'audio',
    fileUrl: '/api/media/fa-coerenza',
    fileSizeKb: 4800,
  },
  {
    id: 'fa-3',
    title: 'Video n.1 — Allineamento posturale base',
    description: 'Il primo passo per correggere la tua postura',
    type: 'video',
    fileUrl: '/api/media/fa-video1',
    fileSizeKb: undefined,
  },
  {
    id: 'fa-4',
    title: 'Capitolo 1 di BE SMART',
    description: 'Il capitolo introduttivo del manuale BE SMART in anteprima',
    type: 'pdf',
    fileUrl: '/api/media/pdf/be-smart-cap1',
    fileSizeKb: 1240,
  },
];

// ─── Notifiche mock ──────────────────────────────────────────
export const MOCK_NOTIFICATIONS: Notification[] = [
  {
    id: 'n-1',
    type: 'success',
    title: 'Acquisto completato!',
    message: 'Hai acquistato BE SMART. Inizia subito il tuo percorso.',
    read: false,
    createdAt: '2025-03-01T10:05:00Z',
    actionUrl: '/dashboard/corsi',
    actionLabel: 'Vai ai corsi',
  },
  {
    id: 'n-2',
    type: 'info',
    title: 'Nuovo contenuto disponibile',
    message: 'Una nuova traccia audio è stata aggiunta a Fit Anatomy.',
    read: false,
    createdAt: '2025-03-15T09:00:00Z',
    actionUrl: '/dashboard/fit-anatomy',
    actionLabel: 'Scopri',
  },
  {
    id: 'n-3',
    type: 'warning',
    title: 'Conferma la tua email',
    message:
      'Conferma il tuo indirizzo email per sbloccare tutti i contenuti acquistati.',
    read: true,
    createdAt: '2025-03-01T10:06:00Z',
    actionUrl: '/dashboard/profilo',
    actionLabel: 'Vai al profilo',
  },
];

// ─── Progress mock ──────────────────────────────────────────
export const MOCK_PROGRESS: Progress[] = [
  {
    userId: 'u-001',
    courseId: 'be-smart',
    lessonId: 'lesson-03',
    secondsWatched: 342,
    completedLessonIds: ['lesson-01', 'lesson-02'],
    lastWatchedAt: '2025-04-10T18:30:00Z',
    completionPercent: 0,
    lessons: undefined,
  },
];

// ─── Orders mock ──────────────────────────────────────────
export const MOCK_ORDERS: AdminOrder[] = [
  {
    id: 'ord-001',
    userId: 'u-001',
    userEmail: 'user@test.com',
    userFirstName: 'Giulia',
    userLastName: 'Rossi',
    courseId: 'be-smart',
    courseTitle: 'Be Smart',
    amount: 97,
    status: 'completed',
    paymentProvider: 'stripe',
    createdAt: '2024-11-15T10:30:00Z',
  },
  {
    id: 'ord-002',
    userId: 'f-001',
    userEmail: 'free@test.com',
    userFirstName: 'Sara',
    userLastName: 'Bianchi',
    courseId: 'be-smart',
    courseTitle: 'Be Smart',
    amount: 97,
    status: 'pending',
    paymentProvider: 'satispay',
    createdAt: '2025-01-05T16:45:00Z',
  },
  {
    id: 'ord-003',
    userId: 'u-001',
    userEmail: 'user@test.com',
    userFirstName: 'Giulia',
    userLastName: 'Rossi',
    courseId: 'be-smart',
    courseTitle: 'Be Smart',
    amount: 97,
    status: 'refunded',
    paymentProvider: 'paypal',
    createdAt: '2024-12-01T09:00:00Z',
  },
];

// ─── Helpers ─────────────────────────────────────────────────

/** Restituisce i corsi acquistati dall'utente */
export const getUserCourses = (purchasedIds: string[]): Course[] =>
  purchasedIds.map((id) => MOCK_COURSES[id]).filter(Boolean);

/** Formatta i secondi in mm:ss o hh:mm:ss */
export const formatDuration = (seconds: number): string => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  if (h > 0) {
    return `${h}:${String(m).padStart(2, '0')}:${String(s).padStart(2, '0')}`;
  }
  return `${m}:${String(s).padStart(2, '0')}`;
};

/** Calcola la percentuale di completamento di un corso */
export const calcCompletionPercent = (
  course: Course,
  progress: UserProgress
): number => {
  const cp = progress.courses[course.id];
  if (!cp) return 0;
  const total = course.lessons.length;
  if (total === 0) return 0;
  const completed = course.lessons.filter(
    (l) => cp.lessons[l.id]?.completed
  ).length;
  return Math.round((completed / total) * 100);
};
